import { Alert, AlertTitle } from '@mui/material';

import { LiftAITextLink } from '~/components/utils/helpers';

/**
 * Why AI invoice review can't run on this contract, and what to do about it. The "AI
 * invoice review" field a few inches up reports the state as a chip, which is the fact
 * without the remedy — a customer reading "Not eligible" learns their invoices aren't
 * being checked and nothing about how to change that.
 *
 * Shown only when the contract is ineligible; the eligible case is the chip's job.
 */
export const AiReviewUnavailableNote = () => (
  <Alert severity="info">
    <AlertTitle>AI invoice review can&rsquo;t run on this contract</AlertTitle>
    This contract has no rate sets or monthly pricing, so there is nothing to check an invoice
    against. Upload the contract PDF (
    <LiftAITextLink href="mailto:data@mail.liftai.com" label="data@mail.liftai.com" />) so the
    extraction pipeline can populate pricing, or add at least one rate set or monthly price by
    editing the contract.
  </Alert>
);
